export const OFFLINE_PUNCH_LABELS = Object.freeze({
  PunchIn: 'Clock In',
  PunchOut: 'Clock Out',
  StartBreak: 'Start Break',
  EndBreak: 'End Break',
  StartMeal: 'Start Meal',
  EndMeal: 'End Meal',
  Transfer: 'Transfer',
});

export const OFFLINE_PUNCH_STATUS_LABELS = Object.freeze({
  pending: 'pending',
  submitting: 'submitting',
  retrying: 'retrying',
  failed: 'failed',
});

export const OFFLINE_PUNCH_DELETE_CONFIRM_MESSAGE =
  'Are you sure? This punch may not have been saved on your timecard.  Please inform your manager before deletion.';
